// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".v-drawer-logo[data-v-12508e2b]{align-items:center;color:#252733;display:flex;font-size:24px;font-style:normal;font-weight:700;height:100%;justify-content:center;line-height:40px;width:150px}.logo[data-v-12508e2b]{margin-left:-13px;padding-bottom:7px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
